<!-- This needs to be removed and all of the reference that leads to this component needs to be changed-->
<!-- to the FileList component from the Wizer's core, once the custom slots in a file row are released:-->
<!-- See the checklist before upgrading from 0.5.4 https://bwise.atlassian.net/wiki/spaces/RC/pages/3620798543/Wizer+upgrade+checklists -->
<!-- See https://bitbucket.org/saibwise/wizer/pull-requests/1177&ndash;&gt; for more details about this particular change-->
<template>
  <div
    data-w-component="file-list"
    :class="{
      'w-file-list': true,
      'w-file-list--error': inputError,
      'w-file-list--disabled': inputDisabled,
      'w-file-list--read-only': inputReadOnly,
      'w-file-list--dense': inputDense,
    }"
  >
    <!-- Hidden input for browse files modal -->
    <input
      data-id="fileInput"
      ref="fileInput"
      data-w-element="input"
      v-if="!inputReadOnly && !inputDisabled"
      type="file"
      style="display: none"
      @change.stop.prevent="onBrowseFile"
      :multiple="computedMultiple"
      :accept="allowedTypes"
    />

    <div
      v-if="!uploadedFiles.length && (inputReadOnly || inputDisabled)"
      data-w-element="description"
      class="w-file-list__description"
    >
      {{ $t('wizer.components.file-list.no-files') }}
    </div>

    <div
      ref="dropzone"
      data-w-element="dropzone"
      class="w-file-list__dropzone"
      @dragover.stop.prevent="onDragOver"
      @dragleave.stop.prevent="onDragEnd"
      @drop.stop.prevent="onDropFile"
      v-if="!inputReadOnly && !inputDisabled"
    >
      <Progress
        v-if="uploadProgress"
        data-w-element="progress"
        :value="uploadProgress"
        class="absolute bottom-0"
      />
      <div data-w-element="description" class="w-file-list__description">
        {{ $t('wizer.components.file-list.drop-message') }}
        <span @click="$refs.fileInput.click()" data-w-element="browse" class="w-file-list__link">
          {{ $t('wizer.components.file-list.browse') }}
        </span>
      </div>
    </div>

    <ul data-w-element="list" class="w-file-list__list">
      <li
        v-for="(file, index) in uppyFiles"
        :key="`upload-${index}`"
        data-w-element="item"
        :data-w-id="file.data.label || file.data.name"
        class="w-file-list__list--item"
      >
        <div class="flex items-center w-full">
          <slot name="icon" :file="file">
            <Icon
              src="download-file"
              class="text-gray-500 transition-default"
              :class="{ 'text-green-500': filesDownloadingIds.includes(file.data.id) }"
            />
          </slot>
          <slot name="name" :file="file" :download-action="() => startDownload(file.data)">
            <span
              id="downloadFile"
              @click="startDownload(file.data)"
              data-w-element="download"
              class="w-file-list__list--item-name"
            >
              {{ file.data.label || file.data.name }}
            </span>
          </slot>
          <slot name="action" :file="file">
            <span data-w-element="size" class="w-file-list__list--item-size">
              {{ file.data.fileSizeString }}
            </span>
          </slot>
        </div>
        <template
          v-if="inputMetaData && inputMetaData.readOnly && !inputDisabled && file.data.actions"
        >
          <Icon
            v-for="action in file.data.actions"
            :key="action.id"
            class="w-file-list__action transition-default"
            :src="action.icon"
            @click="action.handler({ download: startDownload, fileData: file.data })"
            v-tooltip.bottom-end="$t(action.label)"
          />
        </template>

        <Icon
          data-w-element="remove"
          class="w-file-list__remove transition-default"
          v-if="!inputReadOnly && !inputDisabled"
          src="trash"
          @click="removeFile(index, file)"
        />
      </li>
    </ul>

    <div v-if="errorMessage" data-w-element="error" class="w-file-list_inputError">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import Uppy from '@uppy/core'
import { saveAs } from 'file-saver'
import Icon from '@wizer/core/components/icon/Icon'
import Progress from '@wizer/core/components/progress/Progress'
import InputMixin from '@wizer/core/mixins/InputMixin'

export default {
  mixins: [InputMixin],
  components: {
    Icon,
    Progress,
  },
  props: {
    maxFileSize: {
      type: Number,
      default: 5242880,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    acceptedExtensions: {
      type: [String, Array],
      default: 'bmp,csv,doc,docx,gif,jpeg,jpg,mov,pdf,png,ppt,pptx,rtf,txt,xls,xlsm,xlsx,zip',
    },
    service: {
      type: Object,
    },
    files: {
      type: [Object, Array],
    },
  },
  data() {
    return {
      uppy: {},
      uploadProgress: 0,
      errorMessage: null,
      filesDownloadingIds: [],
    }
  },
  methods: {
    onBrowseFile(event) {
      try {
        this.addFilesToUppy(event.target.files)
      } catch (e) {
        if (!e.isRestriction) {
          // is not uppy restriction, rethrow
          throw e
        }
      }
      // clear the html file input, files are managed internally
      this.$refs.fileInput.value = null
    },

    onDragOver() {
      if (this.inputReadOnly || this.inputDisabled) return

      this.$refs.dropzone.classList.add('w-file-list__dragging')
    },

    onDragEnd() {
      if (this.inputReadOnly || this.inputDisabled) return

      this.$refs.dropzone.classList.remove('w-file-list__dragging')
    },

    onDropFile(event) {
      if (this.inputReadOnly || this.inputDisabled) return

      this.$refs.dropzone.classList.remove('w-file-list__dragging')

      this.addFilesToUppy(event.dataTransfer.files)
    },

    addFilesToUppy(files) {
      Array.from(files).forEach((file) => {
        this.uppy.addFile({
          name: file.name,
          type: file.type,
          data: file,
        })
      })
    },

    startDownload(file) {
      if (this.inputDisabled) {
        return
      }

      this.filesDownloadingIds.push(file.id)

      this.downloadFile(file)
    },

    fileService() {
      return this.service ? this.service : this.$wizer.api.files
    },

    downloadFile(file) {
      return this.fileService()
        .download(file)
        .then((blob) => {
          this.filesDownloadingIds = this.filesDownloadingIds.filter((fileId) => fileId !== file.id)
          return saveAs(blob, file.label)
        })
        .catch(() => {
          this.filesDownloadingIds = this.filesDownloadingIds.filter((fileId) => fileId !== file.id)
          return this.uppy.info(
            this.$t('wizer.components.file-list.msg.download-error'),
            'error',
            5000,
          )
        })
    },

    uploadFile(file) {
      this.uploadProgress = 0.5
      return this.fileService()
        .upload(file.data)
        .then((response) => {
          this.uploadProgress = 0
          if (response?.success) {
            this.uploadedFiles = [...this.uploadedFiles, { ...response, _localId: file.id }]
          } else {
            this.uppy.info(this.$t('wizer.components.file-list.msg.upload-error'), 'error', 5000)
            this.uppy.removeFile(file.id)
          }
        })
        .catch(() => {
          this.uploadProgress = 0
          this.uppy.info(this.$t('wizer.components.file-list.msg.upload-error'), 'error', 5000)
          this.uppy.removeFile(file.id)
        })
    },

    removeFile(index, file) {
      return this.fileService()
        .remove(file.data)
        .then((response) => {
          if (response.success) {
            this.uppy.removeFile(file.id)
            const allFiles = this.uploadedFiles
            allFiles.splice(index, 1)
            this.uploadedFiles = allFiles
          } else {
            this.uppy.info(this.$t('wizer.components.file-list.msg.remove-error'), 'error', 5000)
          }
        })
    },

    validateFileBeingAdded(currentFile, allFiles) {
      if (currentFile.id) {
        // setting props needed for uppy but not present in initial data
        currentFile.name = currentFile.label
        currentFile.data = currentFile
        // initial file, no validation needed
        return true
      }

      if (Object.values(allFiles).some((file) => file.name === currentFile.name)) {
        this.uppy.info(
          this.$t('wizer.components.file-list.msg.duplicate-file-error'),
          'warning',
          5000,
        )
        return false
      }

      if (this.allowedTypes) {
        const isCorrectExtension = Object.values(this.allowedTypes).some((suffix) =>
          currentFile.name.toLowerCase().endsWith(suffix),
        )

        if (!isCorrectExtension) {
          this.uppy.info(
            this.$t('wizer.components.file-list.msg.wrong-type-error', [
              this.allowedTypes.map((ext) => ` ${ext}`).toString(),
            ]),
            'warning',
            5000,
          )
          return false
        }
      }

      return true
    },

    updateMessage(newMessage) {
      this.errorMessage = newMessage
    },
  },

  computed: {
    uppyFiles() {
      return this.uppy && this.uppy.getFiles ? this.uppy.getFiles() : []
    },
    inputRuleRequired() {
      return (v) => (v && v.length !== 0) || 'This field is required.'
    },
    computedMaxFileSize() {
      return this.inputMetaData && this.inputMetaData.maxFileSize !== undefined
        ? this.inputMetaData.maxFileSize
        : this.maxFileSize
    },
    computedMultiple() {
      return this.inputMetaData && this.inputMetaData.multiple !== undefined
        ? this.inputMetaData.multiple
        : this.multiple
    },
    computedAcceptedExtensions() {
      return this.inputMetaData && this.inputMetaData.acceptedExtensions !== undefined
        ? this.inputMetaData.acceptedExtensions
        : this.acceptedExtensions
    },
    allowedTypes() {
      if (!this.computedAcceptedExtensions) {
        return null
      }
      if (Array.isArray(this.computedAcceptedExtensions)) {
        return this.computedAcceptedExtensions
      }

      return this.computedAcceptedExtensions
        .split(',')
        .map((fileType) => `.${fileType.trim().toLowerCase()}`)
    },
    uploadedFiles: {
      get() {
        if (!this.inputValue) {
          return []
        }
        if (Array.isArray(this.inputValue)) {
          return this.inputValue
        }
        return [this.inputValue]
      },
      set(val) {
        this.inputValue = val
        this.$emit('update:files', val)
      },
    },
  },

  mounted() {
    this.uppy = new Uppy({
      debug: false,
      id: `uploader-${this.id}`,
      autoProceed: true,
      restrictions: {
        maxFileSize: this.computedMaxFileSize,
        maxNumberOfFiles: this.computedMultiple ? null : 1,
        allowedFileTypes: this.allowedTypes,
      },
      onBeforeFileAdded: (currentFile, files) => this.validateFileBeingAdded(currentFile, files),
    })

    this.uploadedFiles
      .map((f) => ({ ...f, uploadComplete: true, uploadStarted: false }))
      .forEach((f) => this.uppy.addFile(f))

    this.uppy
      .on('file-added', (file) => this.uploadFile(file))
      .on('info-visible', () => this.updateMessage(this.uppy.getState().info.message))
      .on('info-hidden', () => this.updateMessage(null))
  },
}
</script>

<style lang="postcss">
.w-file-list {
  @apply w-full;
}

.w-file-list__dropzone {
  @apply flex flex-col w-full h-10;
  @apply relative;
  @apply justify-between;
  @apply border-2 border-dashed rounded;
  /*height: 2.5rem;*/
  transition: all 0.2s ease-out;
}
.w-file-list--error .w-file-list__dropzone {
  @apply border-red-500 border-2;
}
.w-file-list__description {
  @apply flex;
  @apply items-center;
  @apply justify-center;
  @apply h-full;
  @apply text-sm;
  @apply truncate;
  @apply text-gray-500;
}
.w-file-list__link {
  @apply ml-1;
  @apply text-primary-500;
  @apply cursor-pointer;
}
.w-file-list__link:hover {
  @apply text-primary-800;
  @apply no-underline;
}
.w-file-list__upload {
  @apply mt-3;
}
.w-file-list__upload--disabled {
  @apply pointer-events-none;
  @apply opacity-50;
}
.w-file-list__placeholder {
  @apply mb-2;
}
.w-file-list__placeholder--content {
  @apply flex;
  @apply justify-center;
  @apply items-center;
  @apply m-auto;
  @apply bg-gray-100;
  @apply border;
  @apply border-solid;
  @apply rounded;
  @apply overflow-hidden;

  height: 150px;
}
.w-file-list__dragging {
  @apply bg-primary-100;
  @apply border-primary-500;
}
.w-file-list_inputError {
  @apply flex;
  @apply items-center;
  @apply text-xs;
  @apply font-medium;
  @apply tracking-wide;
  @apply text-red-500;
}
.w-file-list--error .w-file-list_inputError {
  @apply opacity-100;
}
.w-file-list__list {
  @apply w-full;
  @apply overflow-y-auto;

  max-height: 290px;
}
.w-file-list__list--item {
  @apply flex;
  @apply justify-between;
  @apply w-full;
  @apply pt-1;
}
.w-file-list__list--item-name {
  @apply ml-2;
  @apply mr-2;
  @apply flex-grow;
  @apply text-sm;
  @apply cursor-pointer;
  @apply text-primary-500;
}
.w-file-list__list--item-name:hover {
  @apply no-underline;
  @apply cursor-pointer;
  @apply text-primary-800;
}
.w-file-list--disabled .w-file-list__list--item-name {
  @apply opacity-50;
  @apply no-underline;
}
.w-file-list--disabled .w-file-list__list--item-name:hover {
  @apply opacity-50;
  @apply no-underline;
  @apply cursor-default;
}
.w-file-list__list--item-size {
  @apply mx-2;
  @apply text-xs;
  @apply text-gray-500;
}
.w-file-list__downloading {
  @apply mr-2;
  @apply text-xs;
  @apply text-gray-300;
}
.w-file-list__remove {
  @apply text-gray-500;
  @apply p-0 ml-2;
}
.w-file-list__action {
  @apply text-gray-500;
  @apply p-0 ml-2;
}
.w-file-list__remove:hover {
  @apply text-red-500;
  @apply cursor-pointer;
}
.w-file-list--dense .w-file-list__dropzone {
  height: 32px;
}
</style>
